import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { ApiStatuses } from 'coreOld/enums';

export const iconStyle = {
  fontSize: 'inherit',
  marginRight: 20,
  color: '#fff',
  width: 25,
  height: 25,
};

export const closeIconStyle: CSSProperties = {
  position: 'absolute',
  right: 30,
  top: '40%',
  color: '#fff',
};

export const spinnerStyle = {
  width: 25,
  height: 25,
  fill: '#fff',
};

interface WrapperProps {
  showNotification?: boolean;
  type?: ApiStatuses;
  style?: CSSProperties;
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>`
  background-color: ${({ theme }) => theme.colors.loadingNt};
  position: fixed;
  top: 4px;
  width: 99vw;
  min-height: 86px;
  z-index: 999999;
  border-radius: 15px;
  margin-left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  transition: all 1s;
  opacity: ${({ showNotification }) => (showNotification ? '95%' : '0')};
  display: ${({ showNotification }) => !showNotification && 'none'};

  ${({ type }) => {
    switch (type) {
      case ApiStatuses.SUCCESS:
        return css`
          background-color: ${({ theme }) => theme.colors.successNt};
        `;
      case ApiStatuses.ERROR:
        return css`
          background-color: ${({ theme }) => theme.colors.dangerNt};
        `;
      case ApiStatuses.LOADING:
        return css`
          background-color: ${({ theme }) => theme.colors.loadingNt};
        `;
      case ApiStatuses.INFO:
        return css`
          background-color: ${({ theme }) => theme.colors.infoNt};
        `;
      case ApiStatuses.WARNING:
        return css`
          background-color: ${({ theme }) => theme.colors.warningNt};
        `;
      default:
        return css``;
    }
  }};
`;

interface MessageProps {
  children?: ReactNode;
}

export const Message = styled.span<MessageProps>`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 24px;
  font-weight: 600;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
